'use client';

import ProductsNavbar from '../components/Navbar/ProductsNavbar';
import Link from 'next/link';
import { ArrowLeft, Shield, Award, Users, Clock } from 'lucide-react';
import { useState, useEffect } from 'react';
import { isStoreOpen } from '@/lib/storeStatus';

export default function AboutPage() {
  const [storeOpen, setStoreOpen] = useState(false);

  useEffect(() => {
    setStoreOpen(isStoreOpen());
    // Mise à jour toutes les minutes
    const interval = setInterval(() => {
      setStoreOpen(isStoreOpen());
    }, 60000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <ProductsNavbar />


      <section className="relative bg-gradient-to-br from-[#23994F] via-[#1a7840] to-[#156934] text-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            href="/"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Retour à l'accueil</span>
          </Link>

          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6">
              À propos de Verphone
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Votre expert en réparation sous 24h et vente de téléphones d'occasion, reconditionnés et neufs à Saint-Brieuc
            </p>
          </div>
        </div>
      </section>


      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Qui sommes-nous ?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Verphone</strong> est votre spécialiste en réparation de smartphones sous 24h et vente de téléphones d'occasion, reconditionnés et neufs, situé au cœur de Saint-Brieuc. Nous proposons des solutions rapides, économiques et durables pour donner une seconde vie à vos appareils.
              </p>
              <p>
                Que ce soit pour réparer votre téléphone sous 24h, acheter un smartphone d'occasion, reconditionné ou neuf de qualité avec garantie 12 mois, ou trouver les meilleurs accessoires, notre équipe d'experts est là pour vous accompagner.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Valeurs */}
      <section className="py-16 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Nos Valeurs
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Ce qui nous guide au quotidien
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-100 hover:border-[#23994F] transition-all">
              <div className="w-14 h-14 bg-[#23994F]/10 rounded-xl flex items-center justify-center mb-4">
                <Shield size={28} className="text-[#23994F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Qualité & Garantie
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Tous nos produits sont testés et garantis 12 mois pour votre tranquillité d'esprit.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-100 hover:border-[#23994F] transition-all">
              <div className="w-14 h-14 bg-[#23994F]/10 rounded-xl flex items-center justify-center mb-4">
                <Award size={28} className="text-[#23994F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Expertise
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Une équipe de techniciens qualifiés pour des réparations professionnelles et rapides.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-100 hover:border-[#23994F] transition-all">
              <div className="w-14 h-14 bg-[#23994F]/10 rounded-xl flex items-center justify-center mb-4">
                <Users size={28} className="text-[#23994F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Service Client
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Un accueil chaleureux et des conseils personnalisés pour chaque client.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-100 hover:border-[#23994F] transition-all">
              <div className="w-14 h-14 bg-[#23994F]/10 rounded-xl flex items-center justify-center mb-4">
                <Clock size={28} className="text-[#23994F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Rapidité
              </h3>
              <p className="text-gray-600 leading-relaxed">
                La plupart des réparations effectuées sous moins de 24h.
              </p>
            </div>
          </div>
        </div>
      </section>


      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-[#23994F] to-[#1a7840] rounded-3xl p-8 sm:p-12 text-center text-white">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">
              Vous avez un projet ?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              N'hésitez pas à nous contacter pour toute question ou demande de devis
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:contact@verphone.net"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#23994F] rounded-xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all"
              >
                contact@verphone.net
              </a>
              <Link
                href="/services"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-xl font-bold text-lg hover:bg-white/20 transition-all border-2 border-white/30"
              >
                Nos services
              </Link>
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-white/80">
                <strong className="text-white">Adresse :</strong> 8 Bis Pl. du Guesclin, 22000 Saint-Brieuc
              </p>
              <div className="flex items-center justify-center gap-3 mt-4">
                <p className="text-white/80">
                  <strong className="text-white">Horaires :</strong> Lundi - Samedi : 10:00 - 19:00
                </p>
                <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${storeOpen ? 'bg-white/20' : 'bg-white/10'}`}>
                  <div className={`w-2 h-2 rounded-full ${storeOpen ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`}></div>
                  <span className={`text-xs font-semibold ${storeOpen ? 'text-green-100' : 'text-red-100'}`}>
                    {storeOpen ? 'Ouvert' : 'Fermé'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
